import { Box, Button, makeStyles, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { clinicImpersonated, scanType } from "../../util/functions";
import { useTranslation } from "react-i18next";
import ProcedureHeader from "./procedure-header.component";
import ScanFiles from "./ScanFiles";
import { Checkbox } from "@shopify/polaris";
import axios from "../../util/axios";
import ActiveContext from "../../Context/Context";

const useStyles = makeStyles(() => {
  return {
    fontFamilyAlmarai: {
      fontFamily: "Almarai-semi !important",
    },
    fontFamilyEina: {
      fontFamily: "Eina-semi !important",
    },
    wrapper: {
      padding: "2rem",
      boxShadow:
        "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
    },
    box: {
      display: "flex",
      flexWrap: "wrap",
    },
    titleStyle: {
      height: "16px",
      color: "#303030",
      fontSize: "16px !important",
      letterSpacing: 0,
      lineHeight: "22px",
    },
    titleBox: {
      height: "48px",
      width: "360px",
    },
    replacedTitleBox: {
      marginTop: '2rem',
      marginBottom: '1rem',
    },
    substituteTitleBox: {
      marginTop: '1rem',
      marginBottom: '1rem',
    },
    uploadBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
    },
    saveBtn: {
      display: "block",
      width: "65px",
      marginTop: "0.5rem",
      marginLeft: "auto",
      borderRadius: "4.7px",
      color: "#fff",
      backgroundColor: "#FF2C46",
      "&:hover": {
        backgroundColor: "#FF2C46",
      },
    },
    loadingBox: {
      margin: "0 auto",
      textAlign: "center",
      padding: 30,
      color: "#FF2C46",
    },
    loading: {
      textAlign: "center",
      margin: "0 auto",
      color: "#ff2c46",
    },
    errorMsg: {
      color: "#D72C0D",
      fontSize: "12px !important",
      marginTop: "1rem",
    },
  };
});

export default function AppointmentScans({
  customStyle = {},
  userId,
  disable = false,
  data = { data: {}, isAllProvided: null },
  handleTabsExpand = () => {},
  index = 0,
  appointmentId = null,
  appointmentType = "scans",
  openCloseTabs,
  scrollToExpandedTab,
}) {
  const { data: scansData, isAllProvided, scanner_placeholders } = data;
  const classes = useStyles();
  const [iconScan, setIconScan] = useState(isAllProvided);
  const [success, setSuccess] = useState(false);
  const [imagePreview, setImagePreview] = useState(scansData);
  const [checkedScanFiles, setCheckedScanFiles] = useState(false);
  const [saveCheckBox, setSaveCheckBox] = useState(false);
  const [callHandleSave, setCallHandleSave] = useState(0);

  const [errorMsg, setErrorMsg] = useState("");
  const { t, i18n } = useTranslation();
  const { clinicData } = useContext(ActiveContext);
  const isImpressionClinic = clinicData?.isImpressionClinic;
  const handleIconScanView = (value) => {
    setIconScan(value);
  };

  const handleScanValue = (value) => {
    setImagePreview(value);
    handleDataFetched(value);
  };

  const handleSave = async () => {
    const form_data = new FormData();
    setErrorMsg("");
    form_data.append("sent_via_email", checkedScanFiles);
    form_data.append("procedure", appointmentType?.procedure);
    form_data.append("user_scan_info_id", appointmentId);

    try {
      const res = await axios.post(`/admin/v2/users/${userId}/case-record-scans`, form_data);
      if (res.data.success) {
        handleIconScanView(
          checkedScanFiles ? checkedScanFiles : res.data.isAllProvided
        );
        const data = res.data;
        setImagePreview(data);
        handleScanValue(data);
        handleDataFetched(data);
        setSuccess(true);
      }
    } catch (err) {
      setErrorMsg("Upload failed. Please try again.");
      setSuccess(false);
      console.log(err);
    } finally {
      setSaveCheckBox(false);
    }
  };

  const handleDataFetched = (value) => {
    if (value.data) {
      setImagePreview({
        ...value.data,
      });
      setIconScan(value?.isAllProvided);
    }
    if (value?.sent_via_email === 1) {
      setCheckedScanFiles(true);
    }
  };

  const handleChangeScanFiles = (check) => {
    setSaveCheckBox(true);
    setCheckedScanFiles(check);
    setCallHandleSave(1);
  };

  useEffect(() => {
    if (callHandleSave === 1) {
      handleSave();
      setCallHandleSave(0);
    }
  }, [callHandleSave]);

  useEffect(() => {
    scrollToExpandedTab(index, "scans");
  }, [openCloseTabs]);

  return (
    <ProcedureHeader
      handleTabsExpand={handleTabsExpand}
      type="scans"
      headerTitle={scanType(appointmentType?.procedure)}
      index={index}
      iconCheck={iconScan}
    >
      {openCloseTabs[index]?.scans && (
        <Box
          style={customStyle}
          className={`${classes.wrapper} scans-${index}`}
        >
          {
            <>
              <Box className={classes.titleBox}>
                <Typography
                  className={`${classes.titleStyle} ${
                    i18n.language === "ar"
                      ? classes.fontFamilyAlmarai
                      : classes.fontFamilyEina
                  }`}
                >
                  {t("Upload-Scans")}
                </Typography>
              </Box>
              <ScanFiles
                imagePreview={imagePreview}
                appointmentType={appointmentType}
                disable={disable}
                setSuccess={setSuccess}
                appointmentId={appointmentId}
                handleDataFetched={handleDataFetched}
                userId={userId}
                classes={classes}
                setErrorMsg={setErrorMsg}
                scannerPlaceholders={scanner_placeholders}
                t={t}
              />
              {isImpressionClinic && (
                <Checkbox
                  disabled={clinicImpersonated()}
                  label={t("Scan-files-sent-via-email/3D-scanner")}
                  checked={checkedScanFiles}
                  onChange={handleChangeScanFiles}
                />
              )}
              <Box className={classes.uploadBox}>
                <Button
                  disabled={clinicImpersonated() || disable}
                  className={classes.saveBtn}
                  onClick={() => (saveCheckBox ? handleSave() : () => {})}
                >
                  {success ? t("Saved") : t("Save")}
                </Button>
                <Typography className={classes.errorMsg}>{errorMsg}</Typography>
              </Box>
            </>
          }
        </Box>
      )}
    </ProcedureHeader>
  );
}
